import * as api from '@owl-nest/api-client/next'

export async function load<EXTRA_FIELDS extends string = ''>(
  userId: number,
  extraFields: EXTRA_FIELDS[] = [],
): Promise<api.HttpResult<api.Addresses<EXTRA_FIELDS>>> {
  const response = await api.client('GET /users/:id/addresses', {
    urlParams: { id: String(userId) },
    getParams: { extra_fields: extraFields.join(',') },
  })

  return response.next((success) => success.body)
}

export async function create<EXTRA_FIELDS extends string = ''>(
  userId: number,
  address: api.CreateAddress,
  extraFields: EXTRA_FIELDS[] = [],
): Promise<api.HttpResult<api.Address<EXTRA_FIELDS>>> {
  const response = await api.client('POST /users/:id/addresses', {
    urlParams: { id: String(userId) },
    getParams: { extra_fields: extraFields.join(',') },
    body: address,
  })

  return response.next((response) => response.body)
}

export async function remove(addressId: number): Promise<api.HttpResult<void>> {
  const response = await api.client('DELETE /addresses/:id', {
    urlParams: { id: String(addressId) },
  })

  return response.next((success) => success.body)
}

export async function update<EXTRA_FIELDS extends string = ''>(
  addressId: number,
  address: api.UpdateAddress,
  extraFields: EXTRA_FIELDS[] = [],
): Promise<api.HttpResult<api.Address<EXTRA_FIELDS>>> {
  const response = await api.client('PATCH /addresses/:id', {
    urlParams: { id: String(addressId) },
    getParams: { extra_fields: extraFields.join(',') },
    body: address,
  })

  return response.next((success) => success.body)
}

export function filter<EXTRA_FIELDS extends string>(
  addresses: api.Address<EXTRA_FIELDS>[],
  countries: string[],
): api.Address<EXTRA_FIELDS>[] {
  return addresses.filter((address: api.Address) => {
    if (countries.length === 0) {
      return true
    }
    return countries.includes(address.country)
  })
}
